import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  tableContainer: {
    padding: '20px 20px 100px 20px',
  },
});
